import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('settings', app)

  store.actions.checkIfRefreshIsNeeded = function (context) {
    //if it was loaded with only public settings then needs reload
    if (context.state.list.length < 15) {
      context.dispatch('list')
    }
  }
  store.getters.listByName = function (state) {
    const settingsByName = {}
    state.list.forEach((s) => {
      settingsByName[s['name']] = s
    })

    return settingsByName
  }

  store.getters.settings = function (state) {
    const settings = {}
    state.list.forEach((s) => {
      settings[s.name] = s.value
    })

    return settings
  }
  store.getters.orgType = function (state) {
    let v = ''
    state.list.find((s) => {
      if (s.name === 'orgType') {
        v = s.value
        return true
      }
    })
    return v
  }

  store.getters.client = function (state) {
    let v = ''
    state.list.find((s) => {
      if (s.name === 'client') {
        v = s.value
        return true
      }
    })
    return v
  }
  store.getters.filesDir = function (state) {
    let v = ''
    state.list.find((s) => {
      if (s.name === 'filesDir') {
        v = s.value
        return true
      }
    })
    return v
  }
  store.getters.automatedMemberPayments = function (state) {
    let v = ''
    state.list.find((s) => {
      if (s.name === 'automatedMemberPayments') {
        v = s.value
        return true
      }
    })
    if (v === 'true') {
      return true
    }
    return false
  }

  window.addEventListener('ws:settings', (e) => {
    if (e.detail === 'updated') {
      window.vue.$store.dispatch('settings/list')
    }
  })
  return store
}
